<template>
  <time-line type="simple">
    <time-line-item inverted badge-type="info" v-for="(poolTask, key) in tasks" v-bind:key="key">
      <template v-if="poolTask.objectType === 'poolTask'">
        <b-badge slot="header" variant="info" v-if="poolTask.operation === 0">
          {{$t('views.excmtask.show.returnedTask')}}
        </b-badge>
        <b-badge slot="header" variant="info" v-else-if="poolTask.operation === 1">
          {{$t('views.excmtask.show.takeTask')}}
        </b-badge>
        <b-badge slot="header" variant="info" v-else-if="poolTask.operation === 2 || poolTask.operation === 3">
          {{$t('views.excmtask.show.transferTask')}}
        </b-badge>
        <b-badge slot="header" variant="danger" v-else-if="poolTask.operation === -1">
          {{$t('views.excmtask.show.createTask')}}
        </b-badge>
        <b-badge slot="header" variant="success" v-else-if="poolTask.operation === -2">
          {{$t('views.excmtask.show.closeTask')}}
        </b-badge>
        <div slot="content">
          <p v-if="poolTask.operation === 2 || poolTask.operation === 3">
            {{$t('views.excmtask.show.trasnferTaskToUser')}} - {{poolTask.operationTransferUserData.name}} {{poolTask.operationTransferUserData.surname}}
          </p>
        </div>
      </template>
      <template v-else-if="poolTask.objectType === 'dailyPlanItem'">
        <div slot="header">
          <h5><i class="fa fa-lg fa-exclamation"></i></h5>
          <b-badge variant="info">
            {{$t('views.excmtask.show.dailyPlanItem')}}
          </b-badge>
        </div>
        <div slot="content">
          <p v-if="poolTask.idUserData">
            {{$t('views.excmtask.show.plannedAt')}} <router-link :to="{ name: 'DailyPlanShow', params: { idServiceman: poolTask.idUserData['@id'], date: $moment(poolTask.date).format('YYYY-MM-DD') }}">{{ $moment(poolTask.date).format('YYYY-MM-DD') }}</router-link>, {{$t('views.excmtask.show.plannedBy')}} {{ poolTask.idUserData.name }} {{ poolTask.idUserData.surname }}
          </p>
          <p>{{$t('views.excmtask.show.dailyPlanItemStatus')}}:
            <b v-if="poolTask.status === 1 && item.finished === 0 && !poolTask.dateStart">{{$t('views.excmtask.show.dailyPlanItemStatuses.notOver')}}</b>
            <b v-else-if="poolTask.status === 2 && item.finished === 0">{{$t('views.excmtask.show.dailyPlanItemStatuses.moved')}}</b>
            <b v-else-if="poolTask.status === 1 && poolTask.dateStart && !poolTask.dateStop">{{$t('views.excmtask.show.dailyPlanItemStatuses.started')}}</b>
            <b v-else-if="poolTask.status === 0 && item.finished === 0">{{$t('views.excmtask.show.dailyPlanItemStatuses.held')}}</b>
            <b v-else-if="item.finished === 1">{{$t('views.excmtask.show.dailyPlanItemStatuses.finished')}}</b>
          </p>
          <p v-if="poolTask.holdReason">{{$t('views.excmtask.show.holdReason')}}: {{ poolTask.holdReason }}:</p>
          <p v-if="poolTask.moveReason">{{$t('views.excmtask.show.moveReason')}}: {{ poolTask.moveReason }}:</p>
        </div>
      </template>
      <small slot="footer">
        <!--                {{$moment(poolTask.operationDate).format('YYYY-MM-DD HH:mm')}}<span v-if="poolTask.operationUserData"> - {{poolTask.operationUserData.name}} {{poolTask.operationUserData.surname}}</span>-->
        {{ $moment(poolTask.createdAt).format('YYYY-MM-DD HH:mm') }}
      </small>
    </time-line-item>
  </time-line>
</template>

<script>
import { TimeLine, TimeLineItem } from '../../../../UIComponents'

export default {
  name: 'TaskTimeline',
  components: {
    TimeLine,
    TimeLineItem
  },
  computed: {
    tasks () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.poolTasks.reverse()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    poolTasks: {
      required: true
    }
  }
}
</script>

<style scoped>

</style>
